import { ConfigInterface } from './types';

export const defaultConfig: ConfigInterface = {
    data: { developerpageenabled: false },
    bankregnr: undefined,
    links: {
        degogdinelandingsside: { url: '/forsikre/meld-skade/deg-og-dine' },
        dyrlandingsside: { url: '/forsikre/meld-skade/dyr' },
        husoghyttelandingsside: { url: '/forsikre/meld-skade/hus-og-hytte' },
        innbolandingsside: { url: '/forsikre/meld-skade/innbo' },
        kjoretoylandingsside: { url: '/forsikre/meld-skade/kjoretoy' },
        landbruklandingsside: { url: '/forsikre/meld-skade/landbruk' },
        meldskadelandingsside: { url: '/forsikre/meld-skade' },
        naringlandingsside: { url: '/forsikre/meld-skade/naering' },
        reiselandingsside: { url: '/forsikre/meld-skade/reise' },
        rettshjelplandingsside: { url: '/forsikre/meld-skade/rettshjelp' },
        ansvarlandingsside: { url: '/forsikre/meld-skade/ansvar' },
        minside: { url: '/min-oversikt/forsikring/mine-forsikringer' },
        folgskade: { url: '/min-oversikt/forsikring/folg-skade' },
        glasskadeverksted: { url: '/meld-skade/kjoretoy/skade-pa-bilglass' },
        hundfirstvet: { url: 'forsikring/hundeforsikring/firstvet' },
        kattfirstvet: { url: 'forsikring/katteforsikring/firstvet' },
        avtalebyttekeycloaklink: { url: '/login' },
    },
};
